import store from "@/store";

// axios
import axios from "axios";
window.axios = axios;

import UM from "@/api/user-management";
import Cookies from "js-cookie";
import { redirectToIndex } from "@/shared/redirectToIndex";
import { extractErrCode, normalizePayload } from "@/shared/responsePayload";

axios.defaults.timeout = JSON.parse(localStorage.getItem("timeout")) || 30000;
const exeption = ["reserve", "update", "confirm"];

const setTimeStamp = config => {
  const dt = new Date();
  const timeString = `${dt.getFullYear()}/${dt.getMonth() +
    1}/${dt.getDate()} ${dt.getHours()}:${dt.getMinutes()}:${dt.getSeconds()}`;
  config.params = {
    ...config.params,
    _: new Date(timeString).valueOf()
  };
  return config.params;
};

axios.interceptors.request.use(async config => {
  const expiredTime = Cookies.get("expiredTime");
  const isCallRefresh = Cookies.get("isCallRefresh");
  // debugger;
  let $vue = null;
  for (let i in window.__VUE_HOT_MAP__) {
    const ins = window.__VUE_HOT_MAP__[i].instances;
    if (ins && ins.length) {
      $vue = ins[0];
    }
  }

  if ($vue) {
    if (window.isEnquene) $vue.$store.dispatch("setOverlayLoading", false);
    else $vue.$store.dispatch("setOverlayLoading", true);
  }

  // debugger;
  if (
    !config.url.includes("token") &&
    !isCallRefresh &&
    !config.url.includes("refreshToken") &&
    expiredTime
  ) {
    let currTime = new Date();
    if (
      currTime.valueOf() > JSON.parse(expiredTime) ||
      currTime.valueOf() - JSON.parse(expiredTime) > -300000
    ) {
      Cookies.set("isCallRefresh", true);
      try {
        const { data } = await UM.refreshToken();
        if (data.errCode == "00") {
          await store.dispatch("user/refreshToken", data.userInfo);

          if (config.data?.token) {
            config.data.token = data.userInfo.access_token;
          }
          config.headers.authorization = `Bearer ${data.userInfo.access_token}`;
          Cookies.remove("isCallRefresh");

          if (config.url.indexOf("getS3") === -1) {
            config.params = setTimeStamp(config);
          }
          return config;
        } else {
          console.error("[TOKEN] Refresh Failed", data);
          store.dispatch("user/logout");
        }
      } catch (error) {
        console.info("[TOKEN] Refresh Failed", error);
        Cookies.remove("isCallRefresh");
        store.dispatch("user/logoutToIndex");
        throw new Error("[TOKEN] refresh token error");
      }
    }
  }

  if (config.url.indexOf("getS3") === -1) {
    config.params = setTimeStamp(config);
  }

  return config;
});

// Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    let $vue = null;
    for (let i in window.__VUE_HOT_MAP__) {
      const ins = window.__VUE_HOT_MAP__[i].instances;
      if (ins && ins.length) {
        $vue = ins[0];
      }
    }
    const url = response.config.url.split(/\//g);
    url.reverse();
    // Do something with response data
    Cookies.remove("isCallRefresh");
    response.data = normalizePayload(response.data);
    if (Number(extractErrCode(response.data)) === 999) {
      redirectToIndex("axios-response-errCode-999", {
        url: response && response.config && response.config.url,
      });
      return response;
    } else if (url[0] === "verifyToken") {
      if (response.data.errCode === "00" && !response.data.valid) {
        store.dispatch("user/logout");
        store.dispatch("login/show");
        throw new Error("[TOKEN] TOKEN expired");
      } else if (response.data.errCode !== "00") {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve(axios.request(response.config));
          }, 5000);
        });
      }
    } else if (
      (url[0] !== "token" &&
        !!response.data &&
        Number(response.data.errCode) === 103) ||
      (url[0] === "token" &&
        !!response.data &&
        [103, 102, 101].includes(Number(response.data.errCode)))
    ) {
      // debugger
      store.dispatch("user/logout");
      store.dispatch("login/show");
      throw new Error("[TOKEN] TOKEN expired");
    }
    setTimeout(() => {
      if ($vue && $vue.$store.getters.overlayLoading && !window.isEnquene) {
        $vue.$store.dispatch("setOverlayLoading", false);
      }
    }, 2000);
    return response;
  },
  error => {
    if (!error) return Promise.reject(error);
    const errCode = Number(
      extractErrCode(error && error.response && error.response.data)
    );
    if (errCode === 999) {
      redirectToIndex("axios-error-errCode-999", {
        url: error && error.config && error.config.url,
        status: error && error.response && error.response.status,
      });
      return Promise.reject(error);
    }

    const url = error.config.url.split(/\//g);
    url.reverse();
    let $vue = null;
    for (let i in window.__VUE_HOT_MAP__) {
      const ins = window.__VUE_HOT_MAP__[i].instances;
      if (ins && ins.length) {
        $vue = ins[0];
      }
    }

    if (!(exeption.includes(url[0]) && url.includes("ticket"))) {
      const reload = localStorage.getItem("hasReload")
        ? JSON.parse(localStorage.getItem("hasReload"))
        : [];
      if (!reload.includes(url[0])) {
        reload.push(url[0]);
        localStorage.setItem("error hasReload", JSON.stringify(reload));
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve(axios.request(error.config));
          }, 5000);
        });
      } else {
        reload.splice(reload.indexOf(url[0]), 1);
        localStorage.setItem("error hasReload", JSON.stringify(reload));
      }
    }

    if ($vue && $vue.$store.getters.overlayLoading && !window.isEnquene) {
      $vue.$store.dispatch("setOverlayLoading", false);
    }
    return Promise.reject(error);
  }
);

export default axios;
